import layout from 'app/fuse-layouts/layout/Layout';

const FuseLayouts = { layout };

export default FuseLayouts;
